import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Chip,
  FormControl,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Form, FormikProvider, useFormik } from "formik";
import {
  addKra,
  bulkTagging,
  bulkUploadGoals,
  getAllKras,
  getAssignedKra,
} from "../../../redux/features/appraisalSlice";
import UploadImg from "../../../img/uploadIcon.jpg";
import * as XLSX from "xlsx";

const ImportData = ({ dispatchData, tagImport, library }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading } = useSelector((state) => state.appraisal);
  const [excellConvertionLoading, setExcellConvertionLoading] = useState(false);
  const fileInputRef = useRef(null);

  const ValidationSchema = Yup.object().shape({
    excelData: Yup.array().min(1, "Please upload at least one row in Excel"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      excelData: [],
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {

      const dataForTag = values.excelData.map((item) => ({
        ...item,
      }));
      const data = values.excelData.map((item) => {
  let mapped = {};

  if (library === "kra") {
    mapped = {
      appraisal_library_name: item["KRA Name"] || "",
      appraisal_library_description: item["KRA Description"] || "",
    };
  } else if (library === "skills") {
    mapped = {
      appraisal_library_name: item["Skill Name"] || "",
      appraisal_library_description: item["Skill Description"] || "",
    };
  } else if (library === "will") {
    mapped = {
      appraisal_library_name: item["Will Name"] || "",
      appraisal_library_description: item["Will Description"] || "",
    };
  }

  return mapped;
});


      if (tagImport) {
        dispatch(bulkTagging({ data: dataForTag, type: library })).then((res) => {
          if (res.payload.status === "success") {
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
            dispatch(getAssignedKra(dispatchData));
            setOpen(false);
            formik.resetForm();
          } else {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          }
        });
      } else {
        dispatch(addKra({ data: data, type: library })).then((res) => {
          if (res.payload.status === "success") {
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
            dispatch(getAllKras(dispatchData));
            setOpen(false);
            formik.resetForm();
          } else {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          }
        });
      }
    },
  });
  const handleCancel = () => {
    setOpen(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    formik.resetForm();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setExcellConvertionLoading(true);
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const binaryString = e.target.result;
          const workbook = XLSX.read(binaryString, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet);
          formik.setFieldValue("excelData", json);
        } catch (error) {
          console.error("Error parsing Excel file:", error);
          formik.setFieldValue("excelData", []);
        } finally {
          setExcellConvertionLoading(false);
        }
      };
      reader.onerror = () => {
        console.error("File reading error");
        setExcellConvertionLoading(false);
      };
      reader.readAsBinaryString(file);
    }
  };

 const downloadSampleExcel = () => {
  let data = [];
  let filename = "";
  let headers = {};

  if (library === "kra") {
    data = [
      {
        "KRA Name": "",
        "KRA Description": "",
      },
    ];
    headers = {
      "KRA Name": "appraisal_library_name",
      "KRA Description": "appraisal_library_description",
    };
    filename = "sample_kra_template.xlsx";
  } else if (library === "skills") {
    data = [
      {
        "Skill Name": "",
        "Skill Description": "",
      },
    ];
    headers = {
      "Skill Name": "appraisal_library_name",
      "Skill Description": "appraisal_library_description",
    };
    filename = "sample_skill_template.xlsx";
  } else if (library === "will") {
    data = [
      {
        "Will Name": "",
        "Will Description": "",
      },
    ];
    headers = {
      "Will Name": "appraisal_library_name",
      "Will Description": "appraisal_library_description",
    };
    filename = "sample_will_template.xlsx";
  }

  const worksheet = XLSX.utils.json_to_sheet(data, { header: Object.keys(headers) });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
  XLSX.writeFile(workbook, filename);
};


  const downloadSampleExcelTagging = () => {
    const link = document.createElement("a");
    link.href = "/sheets/samplekratagsheet.xlsx";
    link.download = "samplekratagsheet.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <GlobalDialog
      title={"Import Data"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => setOpen(true)}
        >
          <Icon icon="mdi:file-import" width={18} height={18} />
          Import
        </Button>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <img
                  src={UploadImg}
                  style={{
                    width: "50%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                  alt=""
                />
                <Stack direction={"column"} mb={2} mt={2}>
                  <Typography variant="h6" color="gray">
                    Drop attachment here
                  </Typography>
                  <Typography variant="caption">
                    [only xls and xlsx formats are supported]
                  </Typography>
                </Stack>
                <Stack direction={"column"} spacing={2} mb={1}>
                  <TextField
                    name="excelData"
                    inputRef={fileInputRef}
                    InputLabelProps={{ shrink: true }}
                    placeholder="Select an Excel File to Upload"
                    label="Select an Excel File to Upload"
                    variant="outlined"
                    type="file"
                    onChange={handleFileChange}
                    accept=".xlsx, .xls"
                    error={
                      formik.touched.excelData &&
                      Boolean(formik.errors.excelData)
                    }
                    helperText={
                      formik.touched.excelData && formik.errors.excelData
                        ? typeof formik.errors.excelData === "string"
                          ? formik.errors.excelData
                          : "Invalid data in Excel"
                        : ""
                    }
                  />
                </Stack>
                {tagImport ? (
                  <Button
                    size="small"
                    color="primary"
                    sx={{ width: "250px" }}
                    variant="outlined"
                    onClick={downloadSampleExcelTagging}
                  >
                    <Icon
                      icon="vscode-icons:file-type-excel2"
                      width="25"
                      height="25"
                    />
                    <Typography ml={"4px"} variant={"button"}>
                      Download Sample Template
                    </Typography>
                  </Button>
                ) : (
                  <Button
                    size="small"
                    color="primary"
                    sx={{ width: "250px" }}
                    variant="outlined"
                    onClick={downloadSampleExcel}
                  >
                    <Icon
                      icon="vscode-icons:file-type-excel2"
                      width="25"
                      height="25"
                    />
                    <Typography ml={"4px"} variant={"button"}>
                      Download Sample Template
                    </Typography>
                  </Button>
                )}
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}>
                <Stack direction={"row"} spacing={1}>
                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={loading || excellConvertionLoading}
                    size="small"
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    {loading ? "Please wait..." : "Save"}
                  </Button>
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default ImportData;
